var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "top-nav" }, [
    _c("div", { staticClass: "top-nav-inner" }, [
      _c("div", { staticClass: "nav-brand" }, [
        _c("div", { staticClass: "nav-logo" }, [_vm._v("P")]),
        _c("span", { staticClass: "nav-name" }, [_vm._v(_vm._s(_vm.appName))]),
        _c("span", { staticClass: "nav-separator" }, [_vm._v("|")]),
        _c(
          "div",
          { staticClass: "nav-context" },
          [
            _c("span", [_vm._v("Connecting to")]),
            _c("span", { staticClass: "nav-context-strong" }, [
              _vm._v(_vm._s(_vm.platformLabel)),
            ]),
            _vm.storeName
              ? [
                  _c("span", { staticClass: "nav-separator" }, [_vm._v("·")]),
                  _c("span", [_vm._v("Shop Name")]),
                  _c(
                    "span",
                    {
                      staticClass: "nav-store",
                      attrs: { title: _vm.storeName },
                    },
                    [_vm._v(_vm._s(_vm.storeName))]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "nav-secure" }, [
        _c(
          "svg",
          {
            attrs: {
              width: "14",
              height: "14",
              viewBox: "0 0 16 16",
              fill: "currentColor",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M8 1a3.5 3.5 0 0 0-3.5 3.5V6H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.5V4.5A3.5 3.5 0 0 0 8 1zm-2 3.5a2 2 0 1 1 4 0V6H6V4.5z",
              },
            }),
          ]
        ),
        _c("span", [_vm._v("Secure Connection")]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }